import calendarReducer from '@sophocles/features/calendar/slice';

export default calendarReducer;
